import { createAsyncThunk } from '@reduxjs/toolkit';
import { productsClient } from 'api/clients';
import {
  addProductSuccess,
  fetchProductsSuccess,
  requestFailure,
  requestStart,
  updateProductSuccess
} from './productsSlice';

const mapProduct = apiProduct => {
  return {
    id: apiProduct.ProductId,
    model: apiProduct.Model,
    manufacturer: apiProduct.Manufacturer,
    wattage: apiProduct.Wattage,
    terahashes: apiProduct.Terahashes,
    locationId: apiProduct.LocationId,
    price: apiProduct.Price,
    balance: apiProduct.Balance,
    deposit: apiProduct.Deposit,
    condition: apiProduct.Condition,
    imageUri: apiProduct.ImageUri,
    orderType: apiProduct.OrderType,
    electricitySellingPrice: apiProduct.ElectricitySellingPrice
  };
};

// Fetch all products
export const fetchAllProductsThunk = createAsyncThunk(
  'product/fetchAllProductsThunk',
  async (_, { dispatch }) => {
    dispatch(requestStart());
    try {
      const { Products } = await productsClient.getProducts();
      const mappedProducts = Products.map(mapProduct);
      dispatch(fetchProductsSuccess(mappedProducts));
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);

// Add product thunk
export const addProductThunk = createAsyncThunk(
  'product/addProductThunk',
  async ({ formData }, { dispatch }) => {
    dispatch(requestStart());
    try {
      const { product } = await productsClient.addProduct(formData);
      dispatch(addProductSuccess());
      return product;
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);

// Update product thunk
export const updateProductThunk = createAsyncThunk(
  'product/updateProductThunk',
  async ({ id, formData }, { dispatch }) => {
    dispatch(requestStart());
    try {
      const res = await productsClient.updateProduct(id, formData);
      dispatch(updateProductSuccess({ id, data: formData }));
      return res;
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);
